import { Component, inject, OnInit } from '@angular/core';
import { MbqService } from './mbq.service';
import { InventoryService } from '../inventory/inventory.service';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  of,
  Subject,
  switchMap,
  tap,
} from 'rxjs';
import { PoService } from '../po/po.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog.service';
import { ExcelUploadComponent } from '../../../shared/excel-upload/excel-upload.component';
import { environment } from '../../../environments/environment';
import { PaginationComponent } from '../Common/pagination/pagination.component';

@Component({
  selector: 'app-mbq',
  imports: [
    FormsModule,
    RouterModule,
    NgSelectComponent,
    ExcelUploadComponent,
    PaginationComponent
  ],
  templateUrl: './mbq.component.html',

})
export class MbqComponent implements OnInit {
  // Inject services

  productSearch$ = new Subject<string>();
  private mbqService = inject(MbqService);
  private poService = inject(PoService);
  private locationService = inject(InventoryService);
  private toastr = inject(ToastrService);
  private confirmDialog = inject(ConfirmDialogService);
  private isSaved = false;
  searchTerm = '';
  currentPage = 1;
  pageSize = 20;
  products: any[] = [];
  pageCount: any;
  selectedLocation: any = null;
  selectedProduct: any = null;
  loading = false;
  isSearching = false;
  mbqList: any[] = [];
  mbq = 0;
  reorderLevel = 0;
  editRowId: string | null = null;
  editMbq: number = 0;
  editReorderLevel: number = 0;
  constructor() {
    this.getAllEntries();
    this.getAllStores();
  }

  entries: any[] = [];
  locations: any[] = [];

  getAllEntries() { }
  baseUrl = environment.apiUrl;

  ngOnInit(): void {
    this.productSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter((term) => !!term && term.length >= 3),
        tap(() => (this.isSearching = true)),
        switchMap((term) =>
          this.poService.searchProducts(term).pipe(
            map((res: any) => res?.data || []),
            catchError(() => of([])),
            tap(() => (this.isSearching = false))
          )
        )
      )
      .subscribe((data) => {
        this.products = data;
      });
  }

  getAllStores() {
    this.locationService.getAllStores().subscribe({
      next: (data: any) => {
        this.locations = data;

        console.log(data);
      },
      error: (err) => {
        console.error('Error fetching locations', err);
      },
    });
  }

  addMbq() {
    let body = {
      sku: this.selectedProduct.sku,
      variantId: this.selectedProduct.variants[0].id,
      productName: this.selectedProduct.longDescription,
      mbq: this.mbq,
      reorderLevel: this.reorderLevel,
    };
    this.mbqList.push(body);
    this.resetAddFields();
  }

  // onLocationChange() {
  //   if (!this.selectedLocation) {
  //     this.mbqList = []; // ✅ Reset MBQ list if no location

  //     return;
  //   }
  //   this.mbqService.getMbList(this.selectedLocation).subscribe({
  //     next: (res: any) => {
  //       this.mbqList = res.data;
  //       this.mbqList.forEach((item) => {
  //         item.productName = item.variant.variantName;
  //       });
  //       this.pageCount = Math.ceil(this.products.length / this.pageSize);
  //     },
  //     error: (err) => {
  //       console.error('Error fetching MBQ entries', err);
  //     },
  //   });
  // }
  onLocationChange() {
    if (!this.selectedLocation) {
      this.mbqList = [];
      this.pageCount = 0; // Set pageCount to 0
      this.currentPage = 1; // Reset current page
      return;
    }
    this.mbqService.getMbqList(this.selectedLocation).subscribe({
      next: (res: any) => {
        // 1. Reset the currentPage to 1 for the new data
        this.currentPage = 1;
        // Store the full dataset
        this.entries = res.data;
        this.entries.forEach((item) => {
          item.productName = item.variant.variantName;
        });
        // 2. Recalculate and update the pagination view
        this.pageCount = Math.ceil(this.entries.length / this.pageSize);
        this.updatePaginatedList(); // Call the new method to update the view
      },
      error: (err) => {
        console.error('Error fetching MBQ entries', err);
      },
    });
  }

  onPageSizeChange(limit: number) {
    this.pageSize = limit;
    this.pageSizeChange();
  }

  pageSizeChange() {
    this.currentPage = 1;
    // Recalculate page count with the new page size
    this.pageCount = Math.ceil(this.entries.length / this.pageSize);
    // Update the view with the new page size
    this.updatePaginatedList();
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.pageCount || page === this.currentPage) return;
    this.currentPage = page;
    // Update the view to show the new page's data
    this.updatePaginatedList();
  }

  // onSearch() {
  //   if (!this.selectedLocation) {
  //     this.toastr.warning('Please select a location first');
  //     return; // ✅ Avoid 400 Bad Request
  //   }
  //   this.mbqService
  //     .searchVariants(this.searchTerm, this.selectedLocation)
  //     .subscribe({
  //       next: (res: any) => {
  //         this.mbqList = res.data;
  //         this.mbqList.forEach((item) => {
  //           item.productName = item.variant.variantName;
  //         });
  //       },
  //       error: (err) => {
  //         console.error('Error searching variants', err);
  //       },
  //     });
  // }
  onSearch() {
    if (!this.selectedLocation) {
      this.toastr.warning('Please select a location first');
      return;
    }
    // Reset currentPage before starting a new search
    this.currentPage = 1;

    this.mbqService
      .searchVariants(this.searchTerm, this.selectedLocation)
      .subscribe({
        next: (res: any) => {
          // Store the full search result dataset
          this.entries = res.data;
          this.entries.forEach((item) => {
            item.productName = item.variant.variantName;
          });
          // Recalculate page count based on search results
          this.pageCount = Math.ceil(this.entries.length / this.pageSize);
          // Update the paginated view
          this.updatePaginatedList();
        },
        error: (err) => {
          console.error('Error searching variants', err);
        },
      });
  }

  customSearchFn(term: string, item: any): boolean {
    term = term.toLowerCase();
    return (
      item?.longDescription?.toLowerCase()?.includes(term) ||
      item?.skuCode?.toLowerCase()?.includes(term)
    );
  }

  async saveMbq() {
    if (!this.selectedLocation) {
      this.toastr.warning('Please select a location before saving MBQ');
      return; // ✅ Avoid 400 Bad Request
    }

    const proceed = await this.confirmDialog.confirm({
      title: 'Save MBQ?',
      message: `Are you sure you want to save MBQ for <strong>${this.mbqList.length}</strong> item(s)? This updates the reorder levels used to raise indents.`,
      confirmText: 'Save',
      cancelText: 'Cancel',
      size: 'lg',
    });
    if (!proceed) return;

    let items = this.mbqList.map((item) => ({
      variantId: item.variantId,
      mbq: item.mbq,
      reorderLevel: item.reorderLevel,
    }));
    let body = { storeId: this.selectedLocation, items };

    this.mbqService.saveMbq(body).subscribe({
      next: (res: any) => {
        if (res) {
          this.toastr.success('MBQ saved successfully');
          this.mbqList = [];
          this.resetForm();
        } else {
          this.toastr.error('Failed to save MBQ');
        }
      },
      error: (err) => {
        console.error('Error saving MBQ', err);
      },
    });
  }

  private resetForm() {
    this.selectedProduct = null;
    this.reorderLevel = 0;
    this.mbq = 0;
    this.selectedLocation = null;
  }

  startEdit(item: any) {
    this.editRowId = item.id;
    this.editMbq = item.mbq;
    this.editReorderLevel = item.reorderLevel;
  }

  cancelEdit() {
    this.editRowId = null;
  }
  saveEdit(item: any) {
    const body = {
      mbq: this.editMbq,
      reorderLevel: this.editReorderLevel,
    };

    this.mbqService.updateMbq(item.id, body).subscribe({
      next: () => {
        item.mbq = this.editMbq;
        item.reorderLevel = this.editReorderLevel;
        this.editRowId = null;
        this.toastr.success('MBQ updated successfully');
      },
      error: () => {
        this.toastr.error('Failed to update MBQ');
      },
    });
  }

  async canDeactivate(): Promise<boolean> {
    if (this.mbqList.length > 0 && !this.isSaved) {
      return this.confirmDialog.confirm({
        title: 'Discard changes?',
        message:
          'You have unsaved changes in <strong>MBQ</strong>. Are you sure you want to leave this page?',
        confirmText: 'Leave',
        cancelText: 'Stay',
        size: 'lg',
      });
    }
    return true;
  }

  private resetAddFields() {
    this.selectedProduct = null;
    this.reorderLevel = 0;
    this.mbq = 0;
  }

  handleExcelData(data: any) {
    console.log('Excel uploaded data:', data);

    // Example: Map Excel rows to your MBQ list
    // Assuming Excel has columns [SKU, ProductName, ReorderLevel, MBQ]
    const mapped = data.slice(1).map((row: any) => ({
      sku: row[0],
      productName: row[1],
      reorderLevel: row[2],
      mbq: row[3],
    }));

    this.mbqList = [...this.mbqList, ...mapped];
  }

  handleUploadSuccess(response: any) {
    console.log('API Response after successful upload:', response);
    this.toastr.success('Excel file uploaded and data saved successfully.');
    // Refresh the data table from the server
    this.onLocationChange();
  }

  // Optional: New method to handle upload errors
  handleUploadError(error: any) {
    console.error('Upload failed:', error);
    this.toastr.error('Failed to upload Excel file. Please try again.');
  }

  updatePaginatedList() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.mbqList = this.entries.slice(startIndex, endIndex);
  }
}
